

import React, { useEffect } from 'react';
import '../Assets/Css/about.css'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import { FaTools, FaUserTie, FaCogs, FaGavel, FaIndustry, FaClock, FaHandsHelping } from 'react-icons/fa';
import { FaBuilding, FaHardHat, FaShieldAlt } from "react-icons/fa";
import ctaimgabout from '../Assets/Images/aboutctaimg.png'
import { FaBullseye, FaEye, FaHeart } from 'react-icons/fa';
import aboutimg from '../Assets/Images/samashreeaboutimg.png'
import {
  FaRoad,
  FaSolarPanel,
  FaBolt,
  FaWarehouse,
  FaGripLinesVertical,
  FaSign,
  FaTruckMoving,
  FaArrowAltCircleUp,
  FaWrench
} from "react-icons/fa";
import { FaCheckCircle } from 'react-icons/fa';

import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';

export default function About() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const features = [
    {
      title: '20+ Years of Trusted Experience',
      description: 'With over two decades in the industry, we deliver proven expertise.',
      icon: <FaUserTie />,
    },
    {
      title: 'Skilled Team of Engineers and Technicians',
      description: 'Our expert team ensures high-quality workmanship on every project.',
      icon: <FaCogs />,
    },
    {
      title: 'Compliance with All Legal and Safety Standards',
      description: 'We strictly adhere to government regulations and safety protocols.',
      icon: <FaGavel />,
    },
    {
      title: 'Advanced Machinery and Tools',
      description: 'We utilize modern equipment for efficient and precise execution.',
      icon: <FaIndustry />,
    },
    {
      title: 'Timely and Quality-Focused Project Delivery',
      description: 'Committed to completing projects on schedule with superior quality.',
      icon: <FaClock />,
    },
    {
      title: 'Customer-Centric Approach',
      description: 'We prioritize client satisfaction with transparent communication and support.',
      icon: <FaHandsHelping />,
    },
  ];
  const industries = [
    { icon: <FaBuilding />, title: "Industrial Fabrication & Manufacturing" },
    { icon: <FaTools />, title: "Construction & Infrastructure Development" },
    { icon: <FaHardHat />, title: "Road & Transportation Infrastructure" },
    { icon: <FaShieldAlt />, title: "Security & Facility Management Services" },
  ];

  const testimonials = [
    {
      message: "Working with Samashree Enterprises has elevated the standards of our facility management. Their dedication shows in every task.",
      author: "Operations Head",


    },
    {
      message: "Their all-in-one service approach across security, hospitality, and maintenance makes them a unique and dependable partner.",
      author: "Chief Admin Officer",
    },
    {
      message: "We’ve trusted Samashree Enterprises for years. Their commitment to quality and client satisfaction stands out.",
      author: "Project Director",
    },
  ];

  const complianceData = [
    { label: 'CIN', value: 'U25999MH2025PTC440577' },
    { label: 'GST No.', value: '27ABPCS3170C1ZA' },
    { label: 'Udyog Aadhaar Number', value: 'UDYAM-MH-23-0286798' },
    { label: 'Registration Certificate', value: '2520600319824180' },
    { label: 'EPFO', value: 'KDNSK3508020000' },
    { label: 'ESIC No.', value: '36000232020000999' },
    { label: 'PAN Card Number', value: 'ABPCS3170C' }
  ];




  const workItems = [
    {
      icon: <FaGripLinesVertical />,
      text: "All Type of Overhead and Cantilever Gantry Work.",
    },
    {
      icon: <FaWrench />,
      text: "Shuttering Fabrication work for any type bridge work, pier and pier cap.",
    },
    {
      icon: <FaBolt />,
      text: "Fabrication work for decorated street light poles.",
    },
    {
      icon: <FaWarehouse />,
      text: "Fabrication of Trusses for Workshop Installation, Godown for different material stocking.",
    },
    {
      icon: <FaRoad />,
      text: "Highway fencing and Crash Barrier (MBCB) work.",
    },
    {
      icon: <FaTools />,
      text: "Barbod Fencing work.",
    },
    {
      icon: <FaHardHat />,
      text: "Fabrication of Foot Over Bridges – Pipe type or Channel/ I- Section type.",
    },
    {
      icon: <FaBuilding />,
      text: "Toll Plaza Canopy fabrication work.",
    },
    {
      icon: <FaSign />,
      text: "Road Side Sign Boards Frame fabrication.",
    },
    {
      icon: <FaSolarPanel />,
      text: "Solar street Light Pole.",
    },
    {
      icon: <FaTruckMoving />,
      text: "Circular Piling Pipe fabrication work.",
    },
    {
      icon: <FaArrowAltCircleUp />,
      text: "Erection of all type gantries, ROB’s, FOB’s.",
    },
  ];


  // const natureworkItems = [
  //   "All Type of Overhead and Cantilever Gantry Work.",
  //   "Shuttering Fabrication work for any type bridge work, pier and pier cap.",
  //   "Fabrication work for decorated street light poles.",
  //   "Fabrication of Trusses for Workshop Installation, Godown for different material stocking.",
  //   "Highway fencing and Crash Barrier (MBCB) work.",
  //   "Barbod Fencing work.",
  //   "Fabrication of Foot Over Bridges – Pipe type or Channel/ I- Section type.",
  //   "Toll Plaza Canopy fabrication work.",
  //   "Road Side Sign Boards Frame fabrication.",
  //   "Solar street Light Pole.",
  //   "Circular Piling Pipe fabrication work.",
  //   "Erection of all type gantries, ROB’s, FOB’s."
  // ];

  return (
    <>
      <div className="mainnav min-vh-100">

        <Helmet>
          <title>SAMASHREE ENTERPRISES PVT. LTD. | Excellence in Fabrication, Construction & Manpower Services</title>
          <meta
            name="description"
            content="Driven by excellence, Samashree Enterprises offers over 20 years of trusted expertise in industrial fabrication, civil construction, manpower supply, and infrastructure development across India."
          />
          <meta
            name="keywords"
            content="Samashree Enterprises, fabrication services, erection, civil construction, manpower services, industrial sheds, road gantries, crash barriers, facility management India"
          />
          <meta name="author" content="SAMASHREE ENTERPRISES PVT. LTD." />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://www.samashreeenterprises.com/" />

          {/* Open Graph Tags */}
          <meta property="og:title" content="SAMASHREE ENTERPRISES PVT. LTD." />
          <meta property="og:description" content="Reliable experts in fabrication, construction, security, and manpower services with 20+ years of experience." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.samashreeenterprises.com/" />
          <meta property="og:image" content="https://www.samashreeenterprises.com/images/og-image.jpg" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="SAMASHREE ENTERPRISES PVT. LTD." />
          <meta name="twitter:description" content="Trusted leaders in fabrication, erection, and project maintenance. Serving India with quality and commitment." />
          <meta name="twitter:image" content="https://www.samashreeenterprises.com/images/og-image.jpg" />
        </Helmet>

        {/* Hero Section */}
        <section className="hero-section1">
          <div className="overlay" >
            <h1 data-aos="zoom-in">Driven by Excellence</h1>
            <p data-aos="zoom-in">Trusted experts in Services.</p>
            <a href="/contact" className="btn-get" data-aos="fade-up">Get in Touch</a>
          </div>


        </section>

        {/* About Section Preview */}
        {/* About Section */}
        <section className="about-preview py-5">
          <Container>
            <Row className="align-items-center">
              {/* Text Section */}
              <Col md={7}>
                <h2 className='page-title' data-aos="fade-up">ABOUT OUR COMPANY</h2>
                <div style={{ textAlign: 'justify' }} data-aos="zoom-in" data-aos-delay="100">
                  <p >
                    In today’s world, perfection may be rare, but it is unmistakable when achieved. This is what
                    <span className='fw-bold' style={{ color: '#FE8200' }}> " SAMASHREE</span>
                    <span className='fw-bold' style={{ color: '#008080' }}> ENTERPRISES</span>
                    <span className='fw-bold' style={{ color: '#28326E' }}> PRIVATE LIMITED " </span>
                    proudly represents.
                  </p>
                  <p>
                    Fabrication and Erection of industrial and workshop sheds, metal beam cross barriers, foot over bridges, and a range of NH/SH road gantries. Our expertise also extends to roadside fencing, PGRs, and barbed fencing installations & Civil Construction, Routine Maintenance Services, Mark Line Services, Security Services, Hospitality Services (Labor Supply). We have proudly brought smiles to our customers through our dedication to quality.
                  </p>
                  <p>
                    With over 10 years of experience, our company ensures strict compliance with standards set by industry and governmental agencies, supported by our team of skilled engineers in fabrication and erection. SAMASHREE ENTERPRISES is dedicated to delivering excellence and upholding the highest standards in every project we undertake.”
                  </p>
                  <p>
                    Our Company, with the assistance of outside customers and industry experts, ensures compliance with standards set by the industry and government agencies & departments. We have a team of best engineers in the field of fabrication and erection who are committed to the quality of fabrication and erection work. We constantly strive for top-notch in this field with proper quality standards.
                  </p>
                </div>
              </Col>
              {/* Image Section */}
              <Col md={5}>
                <img
                  src={aboutimg}
                  alt="Teamwork and Services"
                  className="img-fluid aboutimg rounded shadow"
                  data-aos="zoom-in" data-aos-delay="200"
                />
              </Col>
            </Row>
          </Container>
        </section>


        <div className="mission-vision-bg py-5">
          <Container>
            <h2 className='page-title' data-aos="fade-up">Our Mission, Vision & Core Values</h2>
            <Row className="text-center justify-content-center align-items-start">

              <Col md={4} className="column-box" data-aos="zoom-in" data-aos-delay="100">
                <FaBullseye className="iconmain" />
                <h4 className="title">Our Mission</h4>
                <p className="text">
                  To deliver high-quality, safe, and sustainable infrastructure and support services that exceed client expectations and contribute to nation-building.
                </p>
              </Col>

              <Col md={4} className="column-box middle-box" data-aos="zoom-in" data-aos-delay="200">
                <FaEye className="iconmain" />
                <h4 className="title">Our Vision</h4>
                <p className="text">
                  To be recognized as one of India's most reliable and innovative engineering and service providers across infrastructure and manpower domains.
                </p>
              </Col>

              <Col md={4} className="column-box" data-aos="zoom-in" data-aos-delay="300">
                <FaHeart className="iconmain" />
                <h4 className="title">Core Values</h4>
                <ul className="values-list text-start">
                  <li>Integrity in everything we do</li>
                  <li>Commitment to quality and deadlines</li>
                  <li>Innovation in construction and planning</li>
                  <li>Respect for our workforce and partners</li>
                  <li>Sustainability in project execution</li>
                </ul>
              </Col>

            </Row>
          </Container>
        </div>

        <section className="why-choose-us py-5 custom-bg">
          <Container>
            <h2 className='text-white page-title' data-aos="fade-up">Why Choose SAMASHREE ENTERPRISES?</h2>
            <Row className="text-center">
              {features.map((feature, index) => (
                <Col key={index} md={4} className="mb-4">
                  <div className="feature-card p-4 h-100 shadow-sm">
                    <div className="icon-box mb-3">{feature.icon}</div>
                    <h5 className="choosetitle fw-bold">{feature.title}</h5>
                    <p>{feature.description}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>


        <section className="industries-we-serve py-5 mb-4 bg-light">
          <Container>
            <h2 className="page-title" data-aos="fade-up">Industries We Serve</h2>
            <Row className="g-4">
              {industries.map((industry, index) => (
                <Col key={index} md={3} sm={6} xs={12}>
                  <div className="industry-card text-center p-4 h-100" data-aos="flip-up" >
                    <div className="industry-icon mb-3" >{industry.icon}</div>
                    <h5 className="industry-title">{industry.title}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>




        <section className="mb-5 natureofwork-section">
          <div className="overlay" />
          <Container className="position-relative z-1">
            <h2 className="page-title" data-aos="fade-up">
              NATURE OF WORK
            </h2>
            {/* <Row>
      <Col md={6}>
        <ul className="work-list">
          {natureworkItems.slice(0, Math.ceil(natureworkItems.length / 2)).map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </Col>
      <Col md={6}>
        <ul className="work-list">
          {natureworkItems.slice(Math.ceil(natureworkItems.length / 2)).map((item, index) => (
            <li key={index + Math.ceil(natureworkItems.length / 2)}>{item}</li>
          ))}
        </ul>
      </Col>
    </Row> */}
            <Row>
              {workItems.map((item, index) => (
                <Col md={4} className="mb-4" key={index}>
                  <div className="work-box d-flex">
                    <div className="icon-box">{item.icon}</div>
                    <p className="work-text">{item.text}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        {/* <section className="nature-of-work-section">
  <Container className="py-4">
    <h2 className="page-title text-center mb-4" data-aos="fade-up">Our Areas of Expertise</h2>
    <Row>
      {workItems.map((item, index) => (
        <Col md={4} className="mb-4" key={index}>
          <div className="work-box d-flex">
            <div className="icon-box">{item.icon}</div>
            <p className="work-text">{item.text}</p>
          </div>
        </Col>
      ))}
    </Row>
  </Container>
</section> */}


        <section className="cta-section text-white py-4">
          <Container>
            <Row className="align-items-center">
              <Col md={6}>
                <div className="d-flex justify-content-center">
                  <img
                    src={ctaimgabout}
                    alt="Professional service team at work"
                    className="img-fluid ctaimg rounded shadow mb-2"
                    data-aos="zoom-in" data-aos-delay="100"
                  />
                </div>
              </Col>

              <Col md={6} className="text-center text-md-start mb-3" data-aos="zoom-in" data-aos-delay="200">
                <h2>Secure. Build. Maintain. Grow.</h2>
                <p className="lead">
                  From guarding your premises to managing civil and industrial projects — we offer end-to-end manpower and project solutions under one trusted name.
                </p>
                <a href="/security" className="btn-learn mt-3">Explore Our Services</a>
              </Col>
            </Row>
          </Container>
        </section>

        <section className='py-5' style={{ backgroundColor: '#cce5e5' }}>
          <Container className=" legal-container d-flex justify-content-center align-items-center">
            <Row className="justify-content-center w-100">
              <Col md={8} lg={6}>
                <Card className="legal-card p-4" data-aos="zoom-in" data-aos-delay="200">
                  <h3 className="page-title">Legal Compliance</h3>
                  <dl className="row legal-list">
                    {complianceData.map(({ label, value }) => (
                      <React.Fragment key={label}>
                        <dt className="col-sm-5 legal-label">{label}:</dt>
                        <dd className="col-sm-7 legal-value">{value}</dd>
                      </React.Fragment>
                    ))}
                  </dl>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>


        <section className="testimonials py-5 bg-light">
          <Container>
            <h2 className="page-title text-center" data-aos="fade-up"> What Our Clients Say </h2>
            <Row>
              <Col md={{ span: 8, offset: 2 }}>
                <Swiper
                  modules={[Autoplay, Pagination]}
                  spaceBetween={30}
                  slidesPerView={1}
                  autoplay={{ delay: 5000 }}
                  loop={true}
                  pagination={{ clickable: true }}
                >
                  {testimonials.map((testimonial, index) => (
                    <SwiperSlide key={index}>
                      <Card className="p-4 mb-4  border-0" data-aos="zoom-in" data-aos-delay="100">

                        <p>⭐️⭐️⭐️⭐️⭐️</p>

                        <p className="mb-3 " style={{ fontStyle: 'italic' }}>“{testimonial.message}”</p>

                        <small className="text-muted">— {testimonial.author}</small>
                      </Card>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
